import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/index.vue'
import Games from '@/pages/Games/index.vue'
import AffiliateActivity from '@/pages/AffiliateActivity/index.vue'
import BetActivity from '@/pages/BetActivity/index.vue'
import BetActivityWeekly from '@/pages/BetActivityWeekly/index.vue'
import BetActivityRegularly from '@/pages/BetActivityRegularly/index.vue'
import BetActivityRegularlyRules from '@/pages/BetActivityRegularly/rules.vue'
import BetActivityRegularlyDetails from '@/pages/BetActivityRegularly/details.vue'
import Promotion from '@/pages/Promotion/index.vue'
import PromotionRule from '@/pages/Promotion/rule.vue'
import PromotionGameRule from '@/pages/Promotion/gameRule.vue'
import Account from '@/pages/Account/index.vue'
import EarnDetails from '@/pages/Invitee/details.vue'
import Earn from '@/pages/Invitee/index.vue'
import Vip from '@/pages/Vip/index.vue'
import CashBack from '@/pages/CashBack/index.vue'
import CashBackRules from '@/pages/CashBack/rules.vue'
import VipMembershipRecord from '@/pages/VipMembershipRecord/index.vue'
import VipBenefits from '@/pages/VipBenefits/index.vue'
import Login from '@/pages/Login/index.vue'
import History from '@/pages/History/index.vue'
import Message from '@/pages/Message/index.vue'
import Edit from '@/pages/Edit/index.vue'
import FAQ from '@/pages/FAQ/index.vue'
import workOrderReview from '@/pages/workOrderReview/index.vue'
import Uploadproof from '@/pages/workOrderReview/Uploadproof.vue'
import UploadproofDepositDetail from '@/pages/workOrderReview/UploadproofDepositDetail.vue'
import UploadproofWithdrawDetail from '@/pages/workOrderReview/UploadproofWithdrawDetail.vue'
import workOrderMessage from '@/pages/workOrderReview/workOrderMessage.vue'
import workOrderMessageDetail from '@/pages/workOrderReview/workOrderMessageDetail.vue'
import proofResultPage from '@/pages/workOrderReview/proofResultPage.vue'
import cashWheel from '@/pages/cashWheel/index.vue'
import WithdrawalSuccessful from '@/pages/WithdrawalSuccessful/index.vue'
import createBankAccount from '@/pages/WithdrawalSuccessful/createBankAccount'
import Terms from '@/pages/Documents/Terms.vue'
import Privacy from '@/pages/Documents/Privacy.vue'
import Responsible from '@/pages/Documents/Responsible.vue'
import LandingTemplate1 from '@/pages/Landing/template1.vue'
import LandingTemplate2 from '@/pages/Landing/template2.vue'
import LandingTemplate3 from '@/pages/Landing/template3.vue'
import LandingTemplate4 from '@/pages/Landing/template5.vue'
import Share from '@/pages/Share/share.vue'
import sharedownload from '@/pages/Share/download.vue'
import AboutUs from '@/pages/Documents/AboutUs.vue'
import KYCPolicy from '@/pages/Documents/KYCPolicy.vue'
import VideoIframe from '@/pages/VideoIframe/index.vue'
import GameCompetition1 from '@/pages/GameCompetition/competition1.vue'
import GameCompetition2 from '@/pages/GameCompetition/competition2.vue'
import GameCompetition3 from '@/pages/GameCompetition/competition3.vue'
import Transfer from '@/pages/Account/transfer.vue'
import Wagering from '@/pages/Games/wagering.vue'
import Bonus from '@/pages/Account/bonus.vue'
import BonusActivity from '@/pages/BonusActivity/index.vue'
import Agent from '@/pages/Agent/index.vue'
import AgentApply from '@/pages/Agent/apply.vue'
import AgentRules from '@/pages/Agent/rules.vue'
import Support from '@/pages/Support/index.vue'
import Treasure from '@/pages/Treasure/index.vue'
import TreasureRules from '@/pages/Treasure/rules.vue'
import ComplainSuggest from '@/pages/Support/complaints.vue'
import Maintaining from '@/pages/Maintaining/index.vue'
import SportsBetting from '@/pages/SportsBetting/index.vue'
import Diwali from '@/pages/Diwali/index.vue'
import DepositActivity from '@/pages/DepositActivity/index.vue'
import FifthAnniversary from '@/pages/FifthAnniversary/index.vue'
import ShareFiesta from '@/pages/ShareFiesta/index.vue'
import BeginnersOnly from '@/pages/BeginnersOnly/index.vue'
import SharingStar from '@/pages/SharingStar/index.vue'
import DepositBonus from '@/pages/DepositBonus/index.vue'
import DiwaliFestival from '@/pages/DiwaliFestival/index.vue'
import NewcomerSignIn from '@/pages/NewcomerSignIn/index.vue'
import depositChannelsPage from '@/pages/depositChannelsPage/index.vue'
import firstDepositDetail from '@/pages/firstDepositDetail/index.vue'
import Predict from '@/pages/Predict/index.vue'
import PredictRecord from '@/pages/PredictRecord/index.vue'
import inviteRules from '../pages/Invitee/rules'
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Home',
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: false,
        title: 'pgebet01.com Login | Access Casino Games & Sports Betting in India',
        description: 'Login to pgebet01.com and play Teen Patti, Roulette, Blackjack & cricket betting instantly. Secure access to India’s most trusted casino & sports betting platform.',
        keywords: 'pgebet01.com Login,Secure Casino Login India,Sports Betting Account Access,Real Money Gaming India.'
      }
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Games',
      name: 'Games',
      component: Games,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/AffiliateActivity',
      name: 'AffiliateActivity',
      component: AffiliateActivity,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/BetActivity',
      name: 'BetActivity',
      component: BetActivity,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/BetActivityWeekly/:category',
      name: 'BetActivityWeekly',
      component: BetActivityWeekly,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/BetActivityRegularly',
      name: 'BetActivityRegularly',
      component: BetActivityRegularly,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/FreeCash',
      name: 'FreeCash',
      component: BetActivityRegularly,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/BetActivityRegularlyRules',
      name: 'BetActivityRegularlyRules',
      component: BetActivityRegularlyRules,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/BetActivityRegularlyDetails',
      name: 'BetActivityRegularlyDetails',
      component: BetActivityRegularlyDetails,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Promotion',
      name: 'Promotion',
      component: Promotion,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true,
        title: 'Casino Bonuses & Sports Betting Offers India | pgebet01.com Promotions',
        description: 'Claim exclusive pgebet01.com promotions! Get 100% welcome bonus, real money free spins, cashback deals, and special cricket betting offers. Boost your play today.',
        keywords: 'Casino Bonuses India,Sports Betting Offers,IPL Betting Promotions.'
      }
    },
    {
      path: '/PromotionRule',
      name: 'PromotionRule',
      component: PromotionRule,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true,
        title: 'Casino Bonuses & Sports Betting Offers India | pgebet01.com Promotions',
        description: 'Claim exclusive pgebet01.com promotions! Get 100% welcome bonus, real money free spins, cashback deals, and special cricket betting offers. Boost your play today.',
        keywords: 'Casino Bonuses India,Sports Betting Offers,IPL Betting Promotions.'
      }
    },
    {
      path: '/PromotionGame',
      name: 'PromotionGame',
      component: PromotionGameRule,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true,
        nocache: true,
        title: 'Casino Bonuses & Sports Betting Offers India | pgebet01.com Promotions',
        description: 'Claim exclusive pgebet01.com promotions! Get 100% welcome bonus, real money free spins, cashback deals, and special cricket betting offers. Boost your play today.',
        keywords: 'Casino Bonuses India,Sports Betting Offers,IPL Betting Promotions.'
      }
    },
    {
      path: '/Deposit',
      name: 'Deposit',
      component: Account,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true,
        nocache: true,
        title: 'Instant Casino Deposit India | UPI, Paytm & NetBanking | pgebet01.com',
        description: 'Deposit instantly at pgebet01.com with UPI, Paytm, NetBanking & cards. Start playing Teen Patti, Blackjack & sports betting with a 100% welcome bonus today!',
        keywords: 'How toDeposit Money,"Supported Payment Methods","Instant Deposit Guide"'
      }
    },
    {
      path: '/Withdraw',
      name: 'Withdraw',
      component: Account,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true,
        nocache: true,
        title: 'Fast Withdrawals Casino India | UPI Instant Cash Out | pgebet01.com',
        description: 'Enjoy lightning-fast withdrawals at pgebet01.com. Cash out winnings instantly via UPI, Paytm & bank transfer. Trusted Indian casino with secure payouts.',
        keywords: 'How to Withdraw Your Winnings, "Withdrawal Timeframes", "Secure Transactions"'
      }
    },
    {
      path: '/Account',
      name: 'Account',
      component: Account,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Earn',
      name: 'Earn',
      component: Earn,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true,
        title: 'Join pgebet01.com Affiliate Program Earn Commissions on Casino & Betting',
        description: 'pgebet01.com Affiliate Program 💼: Earn Commissions for Life! Promote India’s Top Casino & Sports Betting Site. Sign Up Now & Start Earning Passive Income!',
        keywords: 'Casino Affiliate India,Betting Affiliate Program,Earn Money Online.'
      }
    },
    {
      path: '/EarnDetails',
      name: 'EarnDetails',
      component: EarnDetails,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true,
        title: 'Join pgebet01.com Affiliate Program Earn Commissions on Casino & Betting',
        description: 'Become a pgebet01.com Affiliate and Earn Big',
        keywords: 'How the Affiliate Program Works, "Commission Structure", "Sign Up Today"'
      }
    },
    {
      path: '/Vip',
      name: 'Vip',
      component: Vip,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/CashBack',
      name: 'CashBack',
      component: CashBack,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/CashBackRules',
      name: 'CashBackRules',
      component: CashBackRules,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/VipBenefits',
      name: 'VipBenefits',
      component: VipBenefits,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/VipMembershipRecord',
      name: 'VipMembershipRecord',
      component: VipMembershipRecord,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/EarnReward',
      name: 'EarnReward',
      component: Account,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/EarnReferrals',
      name: 'EarnReferrals',
      component: Account,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/History',
      name: 'History',
      component: History,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Message',
      name: 'Message',
      component: Message,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Edit',
      name: 'Edit',
      component: Edit,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/workOrderReview',
      name: 'workOrderReview',
      component: workOrderReview,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Uploadproof',
      name: 'Uploadproof',
      component: Uploadproof,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/UploadproofDepositDetail',
      name: 'UploadproofDepositDetail',
      component: UploadproofDepositDetail,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/UploadproofWithdrawDetail',
      name: 'UploadproofWithdrawDetail',
      component: UploadproofWithdrawDetail,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/workOrderMessage',
      name: 'workOrderMessage',
      component: workOrderMessage,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/workOrderMessageDetail',
      name: 'workOrderMessageDetail',
      component: workOrderMessageDetail,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/proofResultPage',
      name: 'proofResultPage',
      component: proofResultPage,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/cashWheel',
      name: 'cashWheel',
      component: cashWheel,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/WithdrawalSuccessful',
      name: 'WithdrawalSuccessful',
      component: WithdrawalSuccessful,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/createBankAccount',
      name: 'createBankAccount',
      component: createBankAccount,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: false
      }
    },
    {
      path: '/Terms',
      name: 'Terms',
      component: Terms,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true,
        title: 'Terms and Conditions for Online Casino & Betting pgebet01.com',
        description: 'pgebet01.com Terms & Conditions 📜: Fair Play, Bonus Rules & Legal Policies for Online Casino & Sports Betting in India. Read Before You Play!',
        keywords: 'Casino T&C India,Betting Rules,Legal Online Gambling India.'
      }
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true,
        title: 'Privacy Policy for Online Casino & Betting pgebet01.com',
        description: 'Your Privacy Matters at pgebet01.com',
        keywords: 'Data Collection and Usage, "How We Protect Your Information", "Your Rights"'
      }
    },
    {
      path: '/Responsible',
      name: 'Responsible',
      component: Responsible,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true,
        description: 'Play Responsibly at pgebet01.com 🛡️: Set Deposit Limits, Self-Exclusion & Get Support. Enjoy Safe Casino Games & Sports Betting in India. We Care!',
        keywords: 'Responsible Gambling India,Safe Betting Site,Casino Deposit Limits.'
      }
    },
    {
      path: '/Landing1',
      name: 'Landing1',
      component: LandingTemplate1,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Landing2',
      name: 'Landing2',
      component: LandingTemplate3,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Landing3',
      name: 'Landing3',
      component: LandingTemplate2,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Landing4',
      name: 'Landing4',
      component: LandingTemplate4,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Share',
      name: 'Share',
      component: Share,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: false,
        title: 'Join pgebet01.com Affiliate Program Earn Commissions on Casino & Betting',
        description: 'Become a pgebet01.com Affiliate and Earn Big',
        keywords: 'How the Affiliate Program Works, "Commission Structure", "Sign Up Today"',
        ogTitle: 'Hey bro, check this out!',
        ogDescription: 'Hey bro, check this out!'
      }
    },
    {
      path: '/DiwaliFestival',
      name: 'DiwaliFestival',
      component: DiwaliFestival,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/NewcomerSignIn',
      name: 'NewcomerSignIn',
      component: NewcomerSignIn,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/inviteRules',
      name: 'inviteRules',
      component: inviteRules,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/firstDepositDetail',
      name: 'firstDepositDetail',
      component: firstDepositDetail,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/depositChannelsPage',
      name: 'depositChannelsPage',
      component: depositChannelsPage,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/sharedownload',
      name: 'sharedownload',
      component: sharedownload,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Kyc',
      name: 'kyc',
      component: KYCPolicy,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Video',
      name: 'Video',
      component: VideoIframe,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/GameCompetition1',
      name: 'GameCompetition1',
      component: GameCompetition1,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/GameCompetition2',
      name: 'GameCompetition2',
      component: GameCompetition2,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/GameCompetition3',
      name: 'GameCompetition3',
      component: GameCompetition3,
      meta: {
        keepAlive: false, // 2022-08-06 HHY 将keep-alive从true设置为false，即，不让页面使用缓存机制
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/transfer',
      name: 'Transfer',
      component: Transfer,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/wagering',
      name: 'Wagering',
      component: Wagering,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/bonus',
      name: 'Bonus',
      component: Bonus,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/bonusActivity',
      name: 'BonusActivity',
      component: BonusActivity,
      meta: {
        keepAlive: true,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Agent',
      name: 'Agent',
      component: Agent,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Agent/Apply',
      name: 'AgentApply',
      component: AgentApply,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Agent/Rules',
      name: 'AgentRules',
      component: AgentRules,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Support',
      name: 'Support',
      component: Support,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Treasure',
      name: 'Treasure',
      component: Treasure,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Treasure/Rules',
      name: 'TreasureRules',
      component: TreasureRules,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/CsSuggest',
      name: 'ComplainSuggest',
      component: ComplainSuggest,
      meta: {
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/Maintaining',
      name: 'Maintaining',
      component: Maintaining,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/SportsBetting_off',
      name: 'SportsBetting',
      component: SportsBetting,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true,
        title: 'Sports Betting in India Bet on IPL, Cricket & More pgebet01.com',
        description: 'Experience the Thrill of Sports Betting at pgebet01.com',
        keywords: 'Bet on IPL and Cricket, "Live Betting Features", "How to Get Started"'
      }
    },
    {
      path: '/FestivalBonus',
      name: 'Holi',
      component: Diwali,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/DepositActivity',
      name: 'DepositActivity',
      component: DepositActivity,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/dis-5thAnniversary',
      name: '5thAnniversary',
      component: FifthAnniversary,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/ShareFiesta',
      name: 'ShareFiesta',
      component: ShareFiesta,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/DepositAndWin',
      name: 'DepositAndWin',
      component: BeginnersOnly,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/SharingStar',
      name: 'SharingStar',
      component: SharingStar,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/DepositBonus',
      name: 'DepositBonus',
      component: DepositBonus,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/Predict_off',
      name: 'Predict',
      component: Predict,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '/PredictRecord',
      name: 'PredictRecord',
      component: PredictRecord,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: true
      }
    },
    {
      path: '*',
      redirect: '/Home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js